<!-- Different substep -->
<div [ngSwitch]="onboardingSubStep">
    <app-step1-business-activity *ngSwitchCase="1" (next)="onNextClick()" (prev)="onPrevClick()"></app-step1-business-activity>
    <app-step2-business-address *ngSwitchCase="2" (next)="onNextClick()" (prev)="onPrevClick()"></app-step2-business-address>
    <app-step3-key-personnel-details *ngSwitchCase="3" (next)="onNextClick()" (prev)="onPrevClick()"></app-step3-key-personnel-details>
</div>